import { useSuspenseQuery } from '@apollo/client/react';

import { findManyCompanyQuery } from '~/shared/graphql-queries/companies';

const getFindManyCompanyQuery = () => ({
  query: findManyCompanyQuery,
});

export const useFindManyCompanyQuery = ({ limit, filter }) => {
  const useQueryProps = useSuspenseQuery(findManyCompanyQuery, {
    variables: {
      limit,
      filter,
    },
    notifyOnNetworkStatusChange: true,
  });
  const { loading, error, data } = useQueryProps;

  return {
    loading,
    error,
    data,
  };
};
